import { CommonModule, DatePipe as NgDatePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { AppDateMonthAndYearPipe } from './date-month-and-year.pipe';
import { DatePipe } from './date.pipe';
import { NgbDateHelperService } from './ngb/ngb-date-helper.service';
import { NgbDateParserFormatterService } from './ngb/ngb-date-parser-formatter.service';
import { NgbDateToDatePipe } from './ngb/ngb-date-to-date.pipe';

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
    DatePipe,
    AppDateMonthAndYearPipe,
    NgbDateToDatePipe,
  ],
  declarations: [
    DatePipe,
    AppDateMonthAndYearPipe,
    NgbDateToDatePipe,
  ],
  providers: [
    NgDatePipe,
    NgbDateToDatePipe,
    NgbDateParserFormatterService,
    NgbDateHelperService,
  ],
})
export class DateModule {}
